import React, { useState } from 'react'
import StyledH5Heading from '../../../common/components/styledH5Heading/StyledH5Heading'
import AccordionBox from '../../../components/accordionBox/AccordionBox'

const accordionData = [
    {
        question: 'What is the purpose of this project?',
        answer: 'HopeLedger aims to revolutionize crowdfunding through blockchain, ensuring transparency, security, and community-driven support.'
    },
    {
        question: 'How does HopeLedger ensure transparency?',
        answer: 'Using blockchain technology, all transactions are recorded on an immutable ledger, providing a transparent view of fund allocation and project progress.'
    },
    {
        question: 'What are the benefits for backers?',
        answer: 'Backers can trust that their contributions are secure and transparent, with real-time tracking of their impact and active participation in funding decisions.'
    },
    {
        question: 'How does HopeLedger support project creators?',
        answer: 'Creators retain control over their projects, reach a global audience, and benefit from a secure, transparent, and supportive crowdfunding environment.'
    },
];

const FaqSection = () => {

    const [activeElement, setActiveElement] = useState(0);
    const handleClick = (index) => {
        setActiveElement(activeElement === index ? null : index);
    };

    return (
        <div className='w-[90%] flex flex-col gap-10 lg:gap-20 py-20'>
            <div className='text-center'>
                <StyledH5Heading fontColor="text-gradient">FAQ's.</StyledH5Heading>
            </div>
            <div className='flex flex-col-reverse gap-10 lg:flex-row'>
                <div className='lg:w-[40%]'>
                    <img src='/assets/images/phone.webp' alt='Phone' />
                </div>
                <div className='lg:w-[60%]'>
                    {
                        accordionData?.map((item, index) => (
                            <div key={index}
                                onClick={() => handleClick(index)}
                                className={`flex accordion-box transition-all duration-100 cursor-pointer px-6 py-4 flex-col mb-4 border rounded-md bg-dull-black ${activeElement === index ? "border-blue gap-3" : "gap-0"}`}
                            >
                                <AccordionBox activeElement={activeElement} index={index} data={item} />
                            </div>
                        ))
                    }
                </div>
            </div>
        </div>
    )
}

export default FaqSection
